import { createStore, createEffect, createEvent } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { FileUtils, ApiUtils } from '@shared/utils';
import { StatementsApi } from '@shared/api/rest';
import type { DownloadSepaStatementRequest } from '@shared/api/rest/statements';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

interface DownloadSepaStatementEffect extends DownloadSepaStatementRequest {
  name?: string;
}

const downloadSepaStatementEffect = createEffect((params: IQueryParams<DownloadSepaStatementEffect>) =>
  StatementsApi.downloadSepaStatement(params.request, params?.signal),
);
downloadSepaStatementEffect.done.watch((result) => FileUtils.downloadFile(result.result, result.params.request.name));
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(downloadSepaStatementEffect.pending, (_, data) => data)
  .on(downloadSepaStatementEffect.fail, () => false)
  .on(downloadSepaStatementEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(downloadSepaStatementEffect, () => null)
  .on(downloadSepaStatementEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(downloadSepaStatementEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => {
  ApiUtils.errorStoreAbortRequestWatcher(x, $notificationStore.events.setError);
});

downloadSepaStatementEffect.fail.watch((x) => $notificationStore.events.setError(x.error.message));

export const $downloadSepaStatementStore = {
  events: {
    downloadSepaStatement: ApiUtils.wrapperApi(downloadSepaStatementEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: {
    loading: $loadingStore,
    error: $errorStore,
  },
};
